import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { SvbrgSearchProcurementKnowledgeInput, SvbrgSearchProcurementKnowledgeOutput } from '@/generated/gql/graphql';
import { I18nNamespace } from '@/legacy/common/types';

import { ToolResultComponent } from '.';

export const ProcurementKnowledgeTool: ToolResultComponent<
  Tool.searchProcurementKnowledge,
  SvbrgSearchProcurementKnowledgeInput,
  SvbrgSearchProcurementKnowledgeOutput
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available': {
      return <ChatLoadingIndicator message={t(`call`, { query: tool.input?.queryText })} />;
    }

    default:
      return null;
  }
};
